import { hasElements } from 'utils';
import { ValueFacetFilter } from 'models/ValueFacetFilter';

export type ValueChoice = Pick<ValueFacetFilter, 'name' | 'displayName'> & {
  prefix?: string;
};

export type GroupChoice = Pick<ValueFacetFilter, 'name'> & {
  prefix: string;
  facets: ChoiceFilter[];
};

export type ChoiceFilter = ValueChoice | GroupChoice;

export const isGroupChoice = (v: ChoiceFilter): v is GroupChoice =>
  hasElements((v as GroupChoice).facets);
